import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';
import { getParamsType } from '../model/getParamsType';
import { LeadTypeClass } from '../model/LeadType';
import { AdobeDTM } from '../services/adobe-dtm.service';
import { FormControlsAndLogicsService } from '../services/form-controls-and-logics-service.service';
import { SharedService } from '../services/shared.service';

@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss'],
    standalone: false
})
export class BillingComponent implements OnInit,AfterViewInit {
  isFirstQueSelected: boolean = false;
  isThirdQueSelected: boolean = false;
  isSecondQueSelected: boolean = false;
  isFourthQueSelected: boolean = false;
  leadId: any;
  leadType: any;
  loading: boolean = false;
  adobeDtmUrl: any;
  isNoSelected: boolean = false;
  isSplitNoSelected: boolean = false;
  formFieldNames: any = {};
  scrollValue: any = 0;
  scrollStyle: any = '';
  loaderStyle: any = 162;
  clinicListSubscriber: any;
  action:any;
  showPreviousbtn:boolean=true;
  nextBtnText:String="Next";
  clinicId:any;
  previuosButtonTabIndex: any = -1;
  AriaTextSubmitBtn:any;
  constructor(
    public sharedService: SharedService,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private leadTypeClass: LeadTypeClass,
    private adobeDTM: AdobeDTM,
    private fornControlsObj: FormControlsAndLogicsService,
    private el:ElementRef,
    protected $gaService: GoogleAnalyticsService
    ) {

     

     }

     ngAfterViewInit(): void {

     }

    ngOnInit(): void {
      
      window?.top?.postMessage('rx-group-clinic-iframe-container', '*');
      Object.keys(this.billingForm.getRawValue()).forEach((fieldName) => {
        this.formFieldNames[fieldName] = {};
        this.formFieldNames[fieldName]['noFocus'] = false;
      });
      this.route.paramMap.subscribe((params: ParamMap) => {
        this.leadId = params.get('id');
        this.leadType = params.get('leadType');
        this.action=params.get('action');
        this.clinicId=params.get('gid');
        if(this.action=='RE'||this.action=='CE'){
          this.showPreviousbtn=false;
          this.nextBtnText="Back";
        }
        if (this.leadId && (this.leadType === 'update' || !this.leadType))
          this.getLeadDetails();
      });
      this.chechNextButtonValidation();
      const device = this.$gaService.mobileOrLaptopdevice();
    if(device=="Mobile"){
      this.AriaTextSubmitBtn=this.nextBtnText=="Next" ? "Next button double tap to activate the ": "Back button double tap to activate the "
    }
    else{
      this.AriaTextSubmitBtn =this.nextBtnText;
    }
    }

  onBillingFormSubmit(form: NgForm) {
    console.log(form);
    this.router.navigateByUrl('/organisation');
  }
  

  onPreviousClick() {
    this.router.navigateByUrl('/clinic-details')
  }

  navigateBack() {
    this.sharedService.previousStep=true;
    this.router.navigate(['/clinic-details', { id: this.leadId, action : 'frombilling' }]);
  }

  get billingControls() {
    return this.fornControlsObj?.formControls?.billing;
  }
  
  billingForm: FormGroup = this.formBuilder.group({
    aci_billyourparticipantsinsurers: new FormControl(''),
    aci_employeesofthe: new FormControl(''),
    aci_insurancename: new FormControl(''),
    aci_collectpaymentfromparticipants: new FormControl(''),
    aci_billyourcompanydirectly: new FormControl(''),
    aci_responsibleforreimbursementtothepharmacy: new FormControl(''),
    aci_split_costwithparticipants: new FormControl(''),
    entityId: new FormControl(''),
  });

  
  get aciInsuranceName() {
    return this.billingForm.get('aci_insurancename');
  }

  get aciHealthPlan() {
    return this.billingForm.get('aci_employeesofthe');
  }

  get aciReimbursmentOption() {
    return this.billingForm.get('aci_responsibleforreimbursementtothepharmacy');
  }

  
  get aciBillParticipantsInsureres() {
    return this.billingForm.get('aci_billyourparticipantsinsurers');
  }

  get aciCollectPayment() {
    return this.billingForm.get('aci_collectpaymentfromparticipants');
  }

  get aciBillCompanyDirectly() {
    return this.billingForm.get('aci_billyourcompanydirectly');
  }

  get aciSplitCostWithParticipants() {
    return this.billingForm.get('aci_split_costwithparticipants');
  }

  get isBillingOptionsTouchedAndInvalid() {
    return (
      this.aciBillParticipantsInsureres?.dirty ||
      this.aciBillParticipantsInsureres?.touched ||
      this.aciCollectPayment?.dirty ||
      this.aciCollectPayment?.touched ||
      this.aciBillCompanyDirectly?.dirty ||
      this.aciBillCompanyDirectly?.touched ||
      this.aciSplitCostWithParticipants?.dirty ||
      this.aciSplitCostWithParticipants?.touched
    );
  }

  get isBillingOptionsSelected() {
    return (
      this.isFirstQueSelected ||
      this.checkIfFirstCheckboxIsAlreadyChecked() ||
      this.isSecondQueSelected ||
      this.checkIfSecondCheckboxIsAlreadyChecked() ||
      this.isThirdQueSelected ||
      this.checkIfThirdheckboxIsAlreadyChecked() ||
      this.isFourthQueSelected ||
      this.checkIfFourthCheckboxIsAlreadyChecked()
    );
  }
  
  checkIfFirstCheckboxIsAlreadyChecked(): boolean {
    return this.billingForm.value.aci_billyourparticipantsinsurers != '';
  }

  checkIfSecondCheckboxIsAlreadyChecked(): boolean {
    return this.billingForm.value.aci_collectpaymentfromparticipants != '';
  }

  checkIfThirdheckboxIsAlreadyChecked(): boolean {
    return this.billingForm.value.aci_billyourcompanydirectly != '';
  }

  checkIfFourthCheckboxIsAlreadyChecked(): boolean {
    return this.billingForm.value.aci_split_costwithparticipants != '';
  }

  showNextButton(): boolean {
    return (
      this.billingForm.get('aci_billyourparticipantsinsurers')?.value ||
      this.billingForm.get('aci_collectpaymentfromparticipants')?.value ||
      this.billingForm.get('aci_billyourcompanydirectly')?.value ||
      this.billingForm.get('aci_split_costwithparticipants')?.value
    );
  }

  showGenericErrorMessage() {
    return (
      ((this.aciHealthPlan?.dirty || this.aciHealthPlan?.touched) &&
        this.aciHealthPlan?.errors?.required) ||
      ((this.aciInsuranceName?.dirty || this.aciInsuranceName?.touched) &&
        this.aciInsuranceName?.errors?.required &&
        this.formFieldNames.aci_insurancename.noFocus) ||
      ((this.aciReimbursmentOption?.dirty ||
        this.aciReimbursmentOption?.touched) &&
        this.aciReimbursmentOption?.errors?.required) ||
      (this.isBillingOptionsTouchedAndInvalid && !this.isBillingOptionsSelected)
    );
  }

  validateEmpty(ev: any) {
    return ev?.target?.value.trim() != '';
  }

  scrollToInvalidField(){
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    this.sharedService.scrollToPosition(firstInvalidControl);
  }
  
  submit() {
    this.loading = true;
    let submitObj = JSON.parse(JSON.stringify(this.billingForm.value));
    submitObj['entityId'] = this.leadId;
    const url = 'groupclinic/updateClinicLead';
    Object.assign(this.leadTypeClass.billingParams, submitObj);
    this.sharedService.postRequest(url, submitObj).subscribe( {
      complete: () => {
        this.loading = false;
        if(this.action=='RE'||this.action=='CE'){
          this.router.navigate(['/review-details', { id: this.leadId,gid:this.clinicId, action:this.action }])
        }
        else{
        this.router.navigate(['/review-details', { id: this.leadId }]);
      }
      },
     error: (errorResponse) => {
        this.loading = false;
        console.log(errorResponse);
      }
    }
    );
  }


  
  loadAdobeDTM() {
    if (environment.production) {
      this.adobeDtmUrl =
        'https://assets.adobedtm.com/launch-ENd8a7ca47a5e943c9915bbea04a4d1b05.min.js';
    } else {
      this.adobeDtmUrl =
        'https://assets.adobedtm.com/launch-EN7c6a70eddf864f739b21b4930b09faeb-development.min.js';
    }
    this.adobeDTM.loadJsScript(
      this.renderer,
      this.adobeDtmUrl,
      this.adobeDtmUrl
    );
  }


  navigateNext() {
    this.billingForm.markAllAsTouched();
    this.billingForm.markAsDirty();
    this.billingForm.markAsTouched();
    if (
      this.showNextButton() &&
      !this.billingForm.invalid &&
      !this.showGenericErrorMessage()
    ) {
      this.submit();
    } else {
      Object.keys(this.formFieldNames).forEach((fieldName) => {
        this.formFieldNames[fieldName].noFocus = true;
      });
      this.scrollToInvalidField();
    }
  }


  /**This is called to get the lead details from getGroupClinicLead API if we already have data for lead id**/
  getLeadDetails() {
    const url: string = `groupclinic/getClinicLead`;
    const getParams: getParamsType = {
      entityName: 'lead',
      entityId: this.leadId,
      columns:
        '_aci_state_value,address1_city,address1_postalcode,aci_leadtype,address1_stateorprovince,_aci_division_value,companyname,_aci_zipcode_value,emailaddress1,lastname,mobilephone,firstname,telephone1,aci_billyourcompanydirectly,aci_collectpaymentfromparticipants,aci_employeesofthe,aci_insurancename,aci_responsibleforreimbursementtothepharmacy,aci_billyourparticipantsinsurers,aci_companysize,aci_split_costwithparticipants',
    };
    this.loading = true;
    this.sharedService.postRequest(url, getParams).subscribe({
     next: (response) => {
        let spouse;
        let children;
        if (response != null) {
          this.billingForm.patchValue({
            aci_billyourparticipantsinsurers:
              response.aci_billyourparticipantsinsurers,
            aci_employeesofthe: response.aci_employeesofthe
              ? response.aci_employeesofthe.toString()
              : '',
            aci_insurancename: response.aci_insurancename,
            aci_split_costwithparticipants : response.aci_split_costwithparticipants,
            aci_collectpaymentfromparticipants:
              response.aci_collectpaymentfromparticipants,
            aci_billyourcompanydirectly: response.aci_billyourcompanydirectly,
            aci_responsibleforreimbursementtothepharmacy:
              response.aci_responsibleforreimbursementtothepharmacy
                ? response.aci_responsibleforreimbursementtothepharmacy.toString()
                : '',
          });
          this.loading = false;
        }
        
      },
     error: (errorResponse) => {
        this.loading = false;
        console.log(errorResponse);
      }
    }
    );
  }


  chechNextButtonValidation(): void {
    this.billingForm
      .get('aci_billyourparticipantsinsurers')
      ?.valueChanges.subscribe((value) => {
        if (value) {
          this.billingForm
            .get('aci_employeesofthe')
            ?.setValidators([Validators.required]);
          this.billingForm.get('aci_employeesofthe')?.updateValueAndValidity();
          this.billingForm
            .get('aci_insurancename')
            ?.setValidators([Validators.required]);
          this.billingForm.get('aci_insurancename')?.updateValueAndValidity();
          this.billingForm
            .get('aci_responsibleforreimbursementtothepharmacy')
            ?.setValidators([Validators.required]);
          this.billingForm
            .get('aci_responsibleforreimbursementtothepharmacy')
            ?.updateValueAndValidity();
        } else {
          this.billingForm.get('aci_employeesofthe')?.clearValidators();
          this.billingForm.get('aci_employeesofthe')?.updateValueAndValidity();
          this.billingForm.get('aci_insurancename')?.clearValidators();
          this.billingForm.get('aci_insurancename')?.updateValueAndValidity();
          this.billingForm
            .get('aci_responsibleforreimbursementtothepharmacy')
            ?.clearValidators();
          this.billingForm
            .get('aci_responsibleforreimbursementtothepharmacy')
            ?.updateValueAndValidity();
        }
      });
    }

    onSelectingFirstQue(event: any): void {
      if (event.target.checked) {
        this.isFirstQueSelected = true;
      } else {
        this.isFirstQueSelected = false;
        this.billingForm.get('aci_employeesofthe')?.reset();
        this.billingForm.get('aci_insurancename')?.reset();
        this.billingForm
          .get('aci_responsibleforreimbursementtothepharmacy')
          ?.reset();
      }
    }

    
  /**Check second question checkbox is checked or not */
  onSelectingThirdQue(event: any): void {
    if (event.target.checked) {
      this.isThirdQueSelected = true;
     
    } else {
      this.isThirdQueSelected = false;
    }
   
  }

  /**Check third question checkbox is checked or not */
  onSelectingSecondQue(event: any): void {
    if (event.target.checked) {
      this.isSecondQueSelected = true;
  
    } else {
      this.isSecondQueSelected = false;
    }
  }

  
  onSelectingFourthQue(event: any): void {
    if (event.target.checked) {
      this.isFourthQueSelected = true;
      
    } else {
      this.isFourthQueSelected = false;
    }
  }
  onNextButtonFocus(){
    this.previuosButtonTabIndex = 0;
  }
  onPreviousButtonFocus(){
    this.previuosButtonTabIndex = -1;
  }
}
